var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-wrapper',{attrs:{"title":"Space settings","section":_vm.settingsSectionLabel}},[(_vm.showStudentQuotasPanel)?_c('student-quotas'):_vm._e(),(_vm.showFileQuotasPanel)?_c('file-quotas',{attrs:{"space-id":_vm.activeSpaceId,"space-type":_vm.currentSpaceType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }